import type { ChangeEvent, CSSProperties, RefCallback, RefObject } from 'react';
import type React from 'react';
import { Checkbox } from '@mui/material';

import SelectOutlined from 'src/assets/svg/select_outlined.svg?react';
import SelectOutlinedUnchecked from 'src/assets/svg/select_outlined_unchecked.svg?react';

// from MUI's internal definition of DataGrid's Ref type (to allow null)
type DataGridRef<T = HTMLElement> =
  | RefCallback<T | null>
  | RefObject<T | null>
  | null;

// props passed by DataGrid to the baseCheckbox slot
interface DataGridCheckboxProps {
  ref?: DataGridRef<HTMLButtonElement>;
  id?: string;
  autoFocus?: boolean;
  checked?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  indeterminate?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  name?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  size?: 'small' | 'medium' | 'large';
  style?: CSSProperties;
  tabIndex?: number;
  className?: string;
  // allow any aria and data attributes plus other props passed by DataGrid
  [key: string]: any;
}

function UserCheckbox({ ref, ...props }: DataGridCheckboxProps) {
  return (
    <Checkbox
      ref={ref as React.Ref<HTMLButtonElement>}
      checkedIcon={<SelectOutlined />}
      icon={<SelectOutlinedUnchecked />}
      {...props}
    />
  );
}

export default UserCheckbox;
